<template>
  <div class="upload-modal">
    <Modal v-model="showModal1" title="提示">
      <div class="main">
        <h1 style="margin-bottom: 10px">提示：</h1>
        <p style="margin-bottom: 10px">
          1、请务必确保上传的扫描文件<span class="color-red">清晰、位置居正</span>（不可偏移）。 若不符合规范，将会被驳回被要求重新上传！
        </p>

        <p style="margin-bottom: 10px">2、如有问题，请及时联系对应负责人！</p>
        <h2 style="margin-bottom: 10px">请确定您已知晓上述说明！</h2>
      </div>
      <div slot="footer">
        <div class="flex justify-content">
          <Button type="primary" @click="handleCfm">我已知晓上述说明！</Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="showModal2" title="提示">
      <div class="main">
        <UploadBtn
          :accept="accept"
          style="margin-bottom: 8px"
          @on-success="handleUploadPdf"
        >上传文件</UploadBtn>
        <div class="fileInfo" style="margin-bottom: 8px">
          <p v-if="fileName" class="flex align-items fileName">
            <span style="margin-right: 16px">{{ fileName }}</span><Icon
              class="cursor-pointer"
              type="md-close-circle"
              @click="handleDelect"
            ></Icon>
          </p>
        </div>
        <!-- 增加学校端的上传同步到其他端--- -->
        <p v-if="type == 8||(type==3&&portOrg==2)">
          <Checkbox
            v-model="orgSingle"
            :disabled="!!orgFileId"
          >同步上传至机构盖章扫描（彩版）</Checkbox>
        </p>
        <p v-if="type == 8||(type==3&&portOrg==2)">
          <Checkbox
            v-model="operaTionSingle"
            :disabled="!!platFileId"
          >同步上传至平台盖章扫描（彩版）</Checkbox>
        </p>
        <p v-if="type == 8">
          <Checkbox
            v-model="schSingle"
            :disabled="!!schoolFileId"
          >同步上传至学校盖章扫描（彩版）</Checkbox>
        </p>
      </div>
      <div slot="footer">
        <Button class="m-16-430" @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import UploadBtn from '@c/UploadBtn';
import platformApi from '@/request/eduCenter/platform.js';
import axios from 'axios';
export default {
  components: {
    UploadBtn
  },
  props: {
    agreementId: {
      type: String,
      default: ''
    },
    orgFileId: {
      type: String,
      default: ''
    },
    platFileId: {
      type: String,
      default: ''
    },
    schoolFileId: {
      type: String,
      default: ''
    }

    // type: {
    //   type: String,
    //   default: '1' // 1 机构 2 平台 3 学校
    // }
  },
  //
  data() {
    return {
      type: '1', // 1 机构 2 平台 3 学校 8 :配置编辑域pdf文件
      accept: 'application/pdf',
      showModal1: false,
      showModal2: false,
      operaTionSingle: false,
      orgSingle: false,
      schSingle: false,
      fileName: '',
      file: null,
      uploadToken: '',
      UploadUrl: '',
      downloadUrl: '',
      source: null,
      portOrg: Number(localStorage.getItem('portOrg'))
    };
  },
  created() {

  },
  methods: {
    handleShow(type) {
      console.log(type, '拿到的类型----423');
      this.type = type;
      this.handleDelect();
      // this.showModal1 = true;
      this.showModal2 = true;
      this.showModal1 = false;
      this.operaTionSingle = !this.platFileId;
      this.schSingle = !this.schoolFileId;
      this.orgSingle = !this.orgFileId;
    },
    handleUploadPdf(val) {
      const file = val[0];
      if (Math.round(file.size / 1024) > 20480) {
        this.$Message.warning('文件大小不得大小20M');
        return null;
      }
      this.fileName = file['name'];
      this.file = file;
      console.log(file, file.size / 1024);
    },
    handleCfm() {
      this.showModal2 = true;
      this.showModal1 = false;
    },
    handleView() {

    },
    handleCancel() {
      this.showModal2 = false;
    },
    async handleSubmit() {
      if (!this.file) {
        this.$Message.warning('请上传文件');
        return null;
      }
      this.$Spin.show();
      await this.getUploadtoken();

      this.fileId = await this.uploadFile();
      switch (Number(this.type)) {
        case 1:
          await this.saveFileIdRelOrg(this.fileId);
          break;
        case 2:
          await this.saveFileIdRelPlat(this.fileId);
          break;
        case 3:
          await this.saveFileIdRelSchool(this.fileId);
          break;
        case 8:
          await this.saveFinalFileIdRelAgreement(this.fileId);

          break;
      }
      if (this.type == 8 || (this.portOrg == 2 && this.type == 3)) {
        if (this.orgSingle) {
          await this.saveFileIdRelOrg(this.fileId);
        }
        if (this.operaTionSingle) {
          await this.saveFileIdRelPlat(this.fileId);
        }
        if (this.schSingle) {
          await this.saveFileIdRelSchool(this.fileId);
        }
      }
      this.$Spin.hide();
      this.$Message.success('提交成功');
      this.showModal2 = false;
      this.$emit('on-success');
    },
    async saveFileIdRelOrg(fileId) {
      return new Promise(async(resolve, reject) => {
        const res = await platformApi.saveFileIdRelOrg({
          agreementId: this.agreementId,
          fileId: fileId,
          fileName: this.fileName
        });
        if (res.status == 200) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async saveFileIdRelSchool(fileId) {
      return new Promise(async(resolve, reject) => {
        const res = await platformApi.saveFileIdRelSchool({
          agreementId: this.agreementId,
          fileId: fileId,
          fileName: this.fileName
        });
        if (res.status == 200) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async saveFileIdRelPlat(fileId) {
      return new Promise(async(resolve, reject) => {
        const res = await platformApi.saveFileIdRelPlat({
          agreementId: this.agreementId,
          fileId: fileId,
          fileName: this.fileName
        });
        if (res.status == 200) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async saveFinalFileIdRelAgreement(fileId) {
      return new Promise(async(resolve, reject) => {
        const res = await platformApi.saveFinalFileIdRelAgreement({
          agreementId: this.agreementId,
          fileId: fileId,
          fileName: this.fileName
        });
        if (res.status == 200) {
          resolve();
        } else {
          reject();
        }
      });
    },
    handleDelect() {
      this.file = '';
      this.fileName = '';
      this.fileId = '';
    },

    async uploadFile() {
      return new Promise(async(resolve, reject) => {
        const file = this.file;
        const formData = new FormData();
        formData.append('token', this.uploadToken);
        formData.append('file', file);
        const token = localStorage.getItem('loginToken');
        this.source = axios.CancelToken.source();
        var configs = {
          // 上传文件 请求头要设置成下面这样
          headers: {
            token: token,
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: progressEvent => {
            if (progressEvent.lengthComputable) {
            }
          },
          cancelToken: this.source.token
        };
        axios.post(this.UploadUrl, formData, configs).then(res => {
          if (res.data.status === 200) {
            const id = res.data.message.fileId;
            resolve(id);
          } else {
            this.$Spin.hide();
            reject(res.data.error);
            this.$Message.warning(res.data.error);
          }
        }).catch(err => {
          if (err.message) {
            this.$Message.error(err.message);
          }
        }).finally(() => {

        });
      });
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        platformApi.getUploadServiceTemplatePdfApi().then((res) => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fileName {
  display: flex;
  justify-content: space-between;
  width: 99%;
  background-color: #ebf8fe;
  padding: 4px 10px;
}
</style>
